import { Component, Suspense, type ReactNode } from 'react';

/**
 * Fängt ab, wenn eine nachgeladene Seite gar nicht geladen werden kann (lazyPage.ts: der zweite
 * Fehlschlag nach einem Neuladen, also etwa keine Verbindung). Ohne diese Grenze würfe React den
 * Fehler bis ganz nach oben, und die Anwendung wäre eine weiße Seite.
 */
class LadeFehlerGrenze extends Component<{ children: ReactNode }, { fehlgeschlagen: boolean }> {
  state = { fehlgeschlagen: false };

  static getDerivedStateFromError() {
    return { fehlgeschlagen: true };
  }

  render() {
    if (!this.state.fehlgeschlagen) return this.props.children;
    return (
      <div className="error-banner" role="alert">
        <p>
          Diese Seite konnte nicht geladen werden. Bitte die Verbindung prüfen und die Seite neu
          laden.
        </p>
        <button type="button" onClick={() => window.location.reload()}>
          Neu laden
        </button>
      </div>
    );
  }
}

/** Ladeanzeige und Fehlergrenze um eine nachgeladene Seite (`lazyPage`). */
export default function Nachgeladen({ children }: { children: ReactNode }) {
  return (
    <LadeFehlerGrenze>
      <Suspense fallback={<p>Lädt…</p>}>{children}</Suspense>
    </LadeFehlerGrenze>
  );
}
